export default [
  { to: 'akut_urologi', title: 'Akut urologi' },
  { to: 'urologi', title: 'Urologi' },
];
